import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const MainSubContainer = styled.div`
    width: 100%;
    height: auto;
    background: #f5f5f5;

    ${media.mobileDevice`
        height: auto;
        width:auto;
        margin-top: 0%;
    `}
`;

export const AccountGridContainer = styled(Grid)`
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
    padding: 20px;
    // padding-right: 16px;
    // padding-left: 16px;
    ${media.mobileDevice`
    width: auto;
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;

export const AccountGrid = styled(Grid)``;

export const AccountTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    color: #140f4b;
    display: flex;
    justify-content: space-between;
    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    // margin-left: 20px;
    // margin-top: 14px;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    font-size: 15px;
    `}
`;
export const Title = styled.div`
    color: #140f4b;
    font-size: 20px;
    font-family: AvenirNextWorld Demi;
`;

export const AccountDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '16px')};
    color: #202124;
    opacity: 1;
    // margin-left: 20px;
    &:after {
        content: '${(props) => (props.showAstrisk ? ' *' : '')}';
        color: #ef162b;
    }
    ${media.mobileDevice`
    // margin-left: 22px;
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    `}
    ${media.mediumDevice`
    // margin-left: 22px; 
    `}
    ${media.smalDevice`
    // margin-left: 22px; 
    `}
`;

export const ItemGridContainer = styled(Grid)`
    width: 100%;
    background: #ffffff;
    box-shadow: ${({ boxShadow }) =>
        boxShadow ? boxShadow : ' 0px 0px 6px #00000029'};
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
    padding: 20px;
    // padding-right: 16px;
    // padding-left:16px;
    ${media.mobileDevice`
    width: auto;
    padding : ${({ padding }) => (padding ? padding : '20px')};
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;

export const ItemGrid = styled(Grid)`
    padding: ${({ padding }) => (padding ? padding : '10px')};
`;

export const ItemTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    color: #140f4b;
    letter-spacing: -0.12px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
    text-align: left;
    // margin-left: 16px;
    // margin-top: 15px;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`
        margin-left: ${({ isCondensedView, marginLeft })=> isCondensedView ? '20px' : marginLeft };
    `}
`;

export const ItemDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '15px' : '14px')};
    color: #202124;
    opacity: 1;

    ${media.mobileDevice`

    `}
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
    color: ${({ color }) => (color ? color : '#202124')};
    `}
`;

export const ItemTabContainer = styled(Grid)`
    width: 100%;
    background: rgb(232 232 232 / 50%) 0% 0% no-repeat padding-box;
    // opacity: 0.5;
    padding: 6px 0px 5px 22px;
    // margin-left: 17px;
    ${media.mobileDevice`
       margin-bottom: 10px;
       margin-left: 0px;
       margin-right:-20px;
       margin-left:-20px;
       width: calc(100% + 40px) !important;
    `}
    ${media.smalDevice`
    
    `}
`;

export const ItemTabGrid = styled(Grid)`
    ${media.mobileDevice`
        display: none;
    `}
    ${media.smalDevice`
    display: none;
    `}
`;

export const ItemTab = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #3c3c3c;
    letter-spacing: 0px;
    opacity: 0.7;
    margin-left: 16px;
    margin-top: 13px;
`;
export const ItemTabMobile = styled.div`
    display: none;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #3c3c3c;
    letter-spacing: 0px;
    opacity: 0.7;
    margin-left: 16px;
    margin-top: 13px;
    ${media.mediumDevice`
    display: flex;
    opacity: 1;
    `}
    ${media.smalDevice`
    display: flex;
    opacity: 1;
    `}
    ${media.mobileDevice` 
    display: flex;
    opacity: 1;   
    `}
`;
export const ItemTabBodyContainer = styled(Grid)`
    width: 1064px;
    min-height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    opacity: 1;
    margin-top: 10px;
    // margin-left: 17px;
    padding: 20px;
    border-radius: 6px;
    ${media.mobileDevice`
        width: auto;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000029;
        border: 1px solid #74DED6;
        border-radius: 6px;
        // margin-left: 17px ;
    `}
`;
export const ItemTabBodyGrid = styled(Grid)`
    opacity: 1 !important;
    ${media.mobileDevice`
    display: block;    
    // justify-content: flex-end;
    `}
    ${media.mediumDevice`
    display: block;
    `}
    ${media.smalDevice`
    display: block;
    `}
`;

export const ItemAccountDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
            cursor : pointer;
    font-size: ${({ isDemi }) => (isDemi ? '15px' : '12px')};
    letter-spacing: ${({ isDemi }) => (isDemi ? '-0.12px' : '0px')};
    opacity: ${({ isDemi }) => (isDemi ? '1' : '0.9')};
    color: #1010EB;
    // margin-left: 17px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    ${media.mobileDevice`
    margin-top:${({ isDemi }) => (isDemi ? '0px' : '13px')};
    color:  ${({ isDemi }) => (isDemi ? '#1010EB' : '#000000')};
    font-size:'13px'
    `}
    ${media.mediumDevice`
    color:  ${({ isDemi }) => (isDemi ? '#1010EB' : '#000000')};
    `}
    ${media.smalDevice`
    color:  ${({ isDemi }) => (isDemi ? '#1010EB' : '#000000')};
    `}
`;

export const ItemLotDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    letter-spacing: -0.1px;
    opacity: 1;
    color: #140f4b;
    margin-left: 17px;
    ${media.mobileDevice`

    `}
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const ItemPoDetails = styled.div`
    text-align: right;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 14px;
    letter-spacing: -0.7px;
    opacity: 1;
    color: #202124;
    ${media.mobileDevice`
    text-align: left;
    display: flex;
    `}
    ${media.mediumDevice`
    text-align: left;
    display: flex;
    `}
    ${media.smalDevice`
    text-align: left;
    display: flex;
    `}
`;

export const ItemQty = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #000000;
    letter-spacing: -0.13px;
    opacity: 1;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const Brand = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Demi';
    margin-top: 2px;
    // margin-left: 16px;
    font-size: 14px;
    color: #000000;
    opacity: 1;
    ${media.mediumDevice`
    display:flex;
    `}
    ${media.smalDevice`
    display:flex;
    `}
    ${media.mobileDevice`    
    display:flex;
    font-size: 13px;
    `}
`;
export const QtyMobile = styled.div`
    display: none;
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    color: #000000;
    letter-spacing: -0.13px;
    opacity: 1;
    ${media.mediumDevice`
        display:none;
    `}
    ${media.smalDevice`
        display:none;
    `}
    ${media.mobileDevice`    
        display:flex;
        padding-left: ${({ paddingLeft }) =>
            paddingLeft ? paddingLeft : '0px'};
    `}
`;

export const QtyDesktop = styled.div`
    display: flex;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 15px;
    color: #000000;
    letter-spacing: -0.13px;
    opacity: 1;
    ${media.mediumDevice`
    `}
    ${media.smalDevice`
    `}
    ${media.mobileDevice`    
    display:none;
    `}
`;
export const SummaryContainer = styled(Grid)`
    width: 100%;
    min-height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 16px;
    // margin-left: 18px;
    padding: 20px;
    ${media.mobileDevice`
        width: auto;
        margin-top: 0px;
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    
    `}
`;

export const SummaryGrid = styled(Grid)``;

export const Summary = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #202124;
    letter-spacing: 0px;
    opacity: 1;
    text-align: left;
    // margin-left: 18px;
    // margin-top: 16px;
    margin-bottom: 12px;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const SummaryQtyAmount = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #4f4f4f;
    letter-spacing: -0.1px;
    opacity: 1;
    text-align: right;
    // margin-top: 16px;
    // margin-right: 18px;
    margin-bottom: 12px;
    @media only screen and (max-device-width: 1180px) {
        width: ${(props) => props.quantity && '100%'};
        margin-left: ${(props) => props.quantity && '22px'};
    }
    ${media.smalDevice`
    `}
    ${media.mobileDevice` 
    `}
`;

export const SummaryBody = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    color: #393939;
    letter-spacing: 0px;
    opacity: 1;
    margin-top: 12px;

    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const Price = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    letter-spacing: 0px;
    text-align: ${({ textAlign }) =>
        textAlign ? textAlign : 'right !important'};
    opacity: 1;
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    text-decoration: ${({ textdecoration }) => textdecoration};
    -webkit-text-decorations-in-effect: ${({ textdecoration }) =>
        textdecoration};
    @media only screen and (max-device-width: 1180px) {
        width: ${(props) => props.quantity && '100%'};
        margin-left: ${(props) => props.quantity && '14px'};
    }
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const ImageIcon = styled.div`
    display: flex;
    margin-top: 5px;
    margin-left: -3.8rem;
    ${media.mediumDevice`
    margin-left: -2.5rem;
    margin-top: 5px;
    `}
    ${media.smalDevice`
    display: flex;
    margin-left: -2.5rem;
    align-items: center;
    margin-bottom: 4rem;
    margin-top: 5px;
    padding-bottom: 20px;
    `}
    ${media.mobileDevice`  
    display: flex;
    margin-left: -36px;
    width: 200px;
    align-items: center;
    margin-bottom: 4rem;
    margin-top: 0;
    padding-bottom: 20px;
    `}
`;
export const UnitPrice = styled.div`
    // margin-top: 20px;
    font-family: AvenirNextWorld Regular;
    margin-left: 2rem;
    text-align: right;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
    // margin-left:-1rem;
    `}
    ${media.mobileDevice`    
    margin-left: 0;
    margin-top: 0;
    `}
`;
export const TotalPrice = styled.div`
    text-align: right;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    color: #140f4b;
    letter-spacing: -0.13px;
    opacity: 1;
    text-decoration: ${({ textdecoration }) => textdecoration};
    -webkit-text-decorations-in-effect: ${({ textdecoration }) =>
        textdecoration};
    // margin-right: 20px;
    @media only screen and (max-device-width: 1180px) {
        width: ${(props) => props.quantity && '100%'};
        margin-left: ${(props) => props.quantity && '14px'};
    }
    ${media.mediumDevice`
    text-align :center;
    `}
    ${media.smalDevice`
    text-align :center;   
    `}
    ${media.mobileDevice`    
    text-align :center;
    `}
`;

export const ReplenishGridContainer = styled(Grid)`
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    // margin-left: 17px;
    margin-top: 22px;
    padding: 20px;

    ${media.mobileDevice`
    width: auto;
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;
export const ShipmentGridContainer = styled(Grid)`
    width: 100%;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    //margin-left:17px;
    margin-top: 12px;
    padding: 20px;
    // padding-right: 16px;
    // padding-left: 16px;
    ${media.mobileDevice`
    width: auto;
    padding-bottom: 20px;
    margin-top: 10px;
    `}
    ${media.mediumDevice`
    width: auto;
    margin-top: 10px;
    `}
    ${media.smalDevice`
    width: auto;
    margin-top: 10px;
    `}
`;

export const ReplenGrid = styled(Grid)``;

export const ReplenTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    text-align: left;
    color: #140f4b;
    letter-spacing: -0.12px;
    display: flex;
    justify-content: space-between;
    opacity: 1;
    //padding: 16px;
    //margin: 19px 0px 10px 0px;
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    font-size: 15px;
    margin: 0;
    //padding: 12px 0px 12px 16px;
    `}
`;

export const ReplenishBodyGridContainer = styled(Grid)`
    width: 1058px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 20px;
    margin-left: 20px;
    padding-bottom: 25px;
    ${media.mobileDevice`
    width: auto;
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;

export const ReplenBodyGrid = styled(Grid)``;

export const ReplenDetails = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '15px' : '13px')};
    color: ${({ isDemi }) => (isDemi ? '#140F4B' : '#000000')};
    letter-spacing: ${({ isDemi }) => (isDemi ? '-0.12px' : '-0.1px')};
    opacity: 1;
    margin-left: 23px;
    ${media.mobileDevice`

    `}
    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const SubmitGridContainer = styled(Grid)`
    width: 1099px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 18px;
    margin-bottom: 10px;
    padding-bottom: 14px;

    ${media.mobileDevice`
    width: auto;
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;

export const SubmitColoredGridContainer = styled(Grid)`
    width: 1099px;
    background: #fff5e4 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-top: 18px;
    padding-bottom: 14px;
    ${media.mobileDevice`
    width: auto;
    `}
    ${media.mediumDevice`
    width: auto;
    `}
    ${media.smalDevice`
    width: auto;
    `}
`;
export const SubmitGrid = styled(Grid)``;

export const Submit = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    text-align: left;
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;
    margin-left: 13px;

    ${media.mediumDevice`
        
    `}
    ${media.smalDevice`
        
    `}
    ${media.mobileDevice`    
    
    `}
`;

export const EAIcon = styled.div`
    width: 27px;
    height: 21px;
    border-radius: 10px;
    opacity: 1;
    justify-content: center;
    align-items: center;
    background: #ebebeb 0% 0% no-repeat padding-box;
    text-align: center;
    color: #140f4b;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.09px;
    margin-left: 8px;
`;

export const ImageAndHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top:${({ marginTop }) => (marginTop ? marginTop:'')};
    padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '38px')};
     ${media.mobileDevice`
    padding :  ${({ isCondensedView }) =>
        isCondensedView ? '10px 10px 10px 16px' : '20px 16px 0px 16px'};
    background:  ${({ isCondensedView }) =>
        isCondensedView ? '#ffffff' : null};
    box-shadow: ${({ isCondensedView }) =>
        isCondensedView ? '0px 0px 6px #00000029' : null};
    margin-top : ${({ isCondensedView }) => (isCondensedView ? '10px' : null)};
    `};
    ${media.mobileDevice` 
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '')};
    `}; 
`;

export const TopHeader = styled.div`
    //margin-bottom: 13px;
    height: 36px;
    font-size: 20px;
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
    display: flex;
    flex-direction: row;
    color: #030330;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
    color: #202124;
    font-size:20px;
        font-family: 'AvenirNextWorld Demi';
    `};
`;

export const StyledImg = styled.img.attrs((props) => ({
    src: props.src,
    alt: props.name,
}))`
    padding: ${({ padding }) => padding};
`;

export const ImageBox = styled.div`
    width: 44px;
    height: 44px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebeded;
    border-radius: 6px;
    opacity: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SummaryAmount = styled.div`
    display: none;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #4f4f4f;
    letter-spacing: -0.1px;
    opacity: 1;
    text-align: right;
    margin-top: 16px;
    // margin-right: 18px;
    ${media.mediumDevice`
        display: flex ;
        justify-content: flex-end;
    `}
    ${media.smalDevice`
    display: flex ;
    justify-content: flex-end;
    `}
    ${media.mobileDevice`    
    display: flex ;
    justify-content: flex-end;
    `}
`;

export const PriceoverrideAlertMsg = styled.div`
    .alert-msg-wrapper {
        width: 90%;
        ${media.mediumDevice`
            width: 90%;
        `}
        ${media.smalDevice`
            width: 90%;
        `}
        ${media.mobileDevice`    
            width: 100%;
        `}
    }
`;

export const Status = styled.div`
    display: flex;
    justify-content: center;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '')};
    height: 21px;
    width: 59px;
    margin-left: -3rem;
    background: #f2efff 0% 0% no-repeat padding-box;
    border-radius: 4px;

    opacity: 1;
    align-items: center;
    text-align: center;
    ${media.mediumDevice`
        margin-left: -3rem;
    `}
    ${media.mobileDevice`
        margin-left: -1rem;
    `}
    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation : landscape) {
        margin-left: -3rem;
    }
`;

export const StatusText = styled.div`
    font-family: 'AvenirNextWorld bold';
    float: right;
    font-size: 10px;
    letter-spacing: -0.1px;
    color: #654adc;
    //height: 17px;
    width: 50px;
    text-align: center;
    font-weight: bold;
    border-radius: 3px;
    ${media.mobileDevice`     
     
    `}
`;

export const SubItemContainer = styled.div`
    ${media.mobileDevice`     
        height: 231px;
        overflow-y: scroll;
        overflow-x: hidden;
    `}
`;
